module.exports = __webpack_public_path__ + "img/landingPage2.f416ba29.jpg";